export class HelpType {
  e: number;
  name: string;
  note: string;
}

export class Faq {
    type: number;
    title: string;
    content: string;
}

export class HelpResult {
  constructor(){
    this.types = [];
    this.faqs = [];
  }
    types: HelpType[];
    faqs: Faq[];
    company_phone: string;
}
